var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('app-table',{attrs:{"id":_vm.tableId,"options":_vm.options,"mydata":_vm.tabledata},on:{"action":_vm.getListAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }